import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import { db } from '../firebase'
import Typography from '@material-ui/core/Typography';
import useStyles from './Auth/authStyle'
import { Alert } from '@material-ui/lab';
import { resetProducts } from '../store/Cart/cartActions'
import { resetData } from '../store/total/totalActions'
import { withRouter } from "react-router-dom";
import { motion } from 'framer-motion';
import { containerVariants } from '../utils/Variants'
import Container from '@material-ui/core/Container';
import { connect } from 'react-redux'
import { setMessage } from "../store/Auth/userActions"
import { shareWhatsApp } from "../Components/whatsappShare";


const Checkout = (props) => {
    const classes = useStyles();

    const [state, setState] = useState({
        name: '',
        address: '',
        phone: ''
    })

    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentDate, setCurrentDate] = useState(getDate());

    useEffect(() => {
        const { currentUser } = props
        setState({
            ...state,
            email: currentUser !== null ? currentUser.email : ''
        })
    }, [])

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value })
    }

    const WhatsAppButton = () => {
        const handleShareClick = () => {
            const phone = "6281354950219"; // WA harus pakai kode negara, tanpa +
            const textToShare = encodeURIComponent("kak mau pesan...");

            const whatsappAppUrl = `whatsapp://send?phone=${phone}&text=${textToShare}`;
            const whatsappWebUrl = `https://wa.me/${phone}?text=${textToShare}`;

            const ua = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipad|ipod|android|blackberry|iemobile|opera mini/i.test(ua);
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (isMobile) {
            // Mobile → coba buka aplikasi
            window.location.href = whatsappAppUrl;

            // fallback kalau gagal (misalnya Safari blokir)
            setTimeout(() => {
                window.location.href = whatsappWebUrl;
            }, 1200);
            } else {
            // Desktop → buka WhatsApp Web
            if (isSafari) {
                window.location.href = whatsappWebUrl;
            } else {
                window.open(whatsappWebUrl, "_blank");
            }
            }
        };

        return (
            <button className={classes.submit} onClick={handleShareClick}>
            Pesan WhatsApp (081354950219)
            </button>
        );
        };


    const handleOrder = (phone,textToShare) => {
        shareWhatsApp({
            phone: phone, // nomor WA, wajib pakai kode negara
            message: textToShare,
        });
        };
    
    function objectToQueryString(obj) {
        const keys = Object.keys(obj);
        const keyValuePairs = keys.map(key => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
        });
        return keyValuePairs.join('&');
      }

      function getDate() {
        const date = new Date();
        const formattedDate = date.toLocaleString('en-US', { timeZoneName: 'short' });
        return formattedDate;
      }

    const onSubmitHandler = (event) => {
        event.preventDefault()
        
        if (isFormValid(state)) {
            if (props.cartProducts.length) {
                setErrors([])
                setLoading(true)
                // Fungsi yang menerima parameter datetime dan locate, lalu menyimpannya ke koleksi 'iot'
                    const submitIoTData = (datetime, locate) => {
                        db.collection("iot").doc()
                            .set({
                                name: state.name,
                                email: state.email,
                                address: state.address,
                                phone: state.phone,
                                cartProducts: props.cartProducts,
                                totalPrice: props.cartTotal.totalPrice,
                                payment: false,
                                note: null,
                                evidence_payment: null,
                                created_at: currentDate,
                                modified_at: null,
                                // Parameter untuk data IoT (lokasi & datetime)
                                lokasi: locate,
                                datetime: datetime,
                            })
                            .then((data) => {
                                const textToShare = 'Hai, berikut pesanan saya: ' + 'https://warung-angga.vercel.app/orders/' + state.phone + ' | total: Rp.' + props.cartTotal.totalPrice;
                                let number = '6281354950219';
                                handleOrder(number, textToShare);
                                props.resetProducts();
                                props.resetData();
                                props.setMessage("Kami terima pesanan kamu.");
                                props.currentUser == null ? props.history.push('/') : props.history.push('/orders');
                            })
                            .catch(err => {
                                setErrors([].concat(err));
                                setLoading(false);
                            });
                    };

            } else {
                setErrors([].concat({ message: "Tolong pilih barang dan beli ya." }))
                console.log(state);
            }

        }

    }

    const isFormValid = ({ name, phone, address }) => name && phone && address


    const displayErrors = errors => errors.map((error, i) =>
        <span key={i}>{error.message}<br /></span>)


    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
        >
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <Typography component="h1" variant="h5"> Beli</Typography>
                    <form className={classes.form} autoComplete="off" onSubmit={onSubmitHandler}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Nama"
                            name="name"
                            autoComplete="name"
                            autoFocus
                            onChange={handleChange}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="phone"
                            label="Nomor WA(WhatsApp)"
                            type="number"
                            onChange={handleChange}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="address"
                            label="Alamat"
                            type="text"
                            onChange={handleChange}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            className={classes.submit}
                            disabled={loading}>
                            Pesan
                        </Button>
                        <Button 
                            variant="primary" 
                            className={classes.submit}
                            color="secondary"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://wa.me/+6281354950219?text=Hallo, mau pesan&app_absent=0">Pesan WhatsApp(081354950219)</Button>
                        {errors.length > 0 ? (
                            <Alert severity="error">{displayErrors(errors)}</Alert>
                        ) : null}
                    </form>
                </div>
            </Container>
        </motion.div>
    );
}

const mapStateToProps = state => ({
    cartProducts: state.cart.products,
    cartTotal: state.total.data,
    currentUser: state.user.currentUser
});

export default connect(
    mapStateToProps, { resetProducts, resetData, setMessage }
)(withRouter(Checkout));